import { useNavigation } from "@react-navigation/core";
import * as Clipboard from "expo-clipboard";
import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Linking,
  Text,
  TouchableOpacity,
  View,
  Image,
} from "react-native";
import { styles } from "./styles";
import AsyncStorage from "@react-native-async-storage/async-storage";
import paymentService from "../../services/paymentService";
import formatDate from "../../utils/formatDate";
import { formatCoin } from "../../utils/formatNumber";
import toast from "../../utils/toast";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";

const DepositBoleto = () => {
  const navigation = useNavigation();

  const [value, setValue] = useState(0);
  const [boletoCode, setBoletoCode] = useState("");
  const [docUrl, setDocUrl] = useState("");
  const [expirationDate, setExpirationDate] = useState();

  useEffect(() => {
    async function createBoletoPayment() {
      const value = parseFloat(await AsyncStorage.getItem("depositAmount"));
      setValue(value);
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      try {
        const response = await paymentService.createBoleto(token, value);
        const { boleto_code, boleto_document_url, expiration_date } =
          response.data;
        console.log(response.data);
        setBoletoCode(boleto_code);
        setDocUrl(boleto_document_url);
        setExpirationDate(expiration_date);
      } catch (err) {
        const intl = useIntl();
        console.log(err.response.data);
        toast(intl.formatMessage({ id: "depositboleto.deuErrado" }), "#DA1414");
        navigation.navigate("Home");
      }
    }
    createBoletoPayment();
  }, []);

  function openBoleto() {
    Linking.openURL(docUrl);
  }

  const [copied, setCopied] = useState(false);
  function copyToClipboard() {
    Clipboard.setString(boletoCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderTabs
        title={<FormattedMessage id="depositBoleto.titleBoleto" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="depositBoleto.depositeBoleto" />
          </Text>
        }
      />

      {!boletoCode ? (
        <View style={styles.activityIndicatorContainer}>
          <ActivityIndicator
            color="#2797A2"
            size="large"
            style={styles.activityIndicator}
          />
        </View>
      ) : (
        <View style={styles.container}>
          <View>
            <View style={styles.headerInfo}>
              <View style={{ alignSelf: "center" }}>
                <Text style={styles.title}>
                  <FormattedMessage id="depositboleto.boleto" />
                </Text>
                <Text style={styles.value}>
                  <FormattedMessage id="depositboleto.R$" />
                  {formatCoin(value)}
                </Text>
              </View>
            </View>

            <Text style={styles.explanationText}>
              <FormattedMessage id="depositboleto.copieCodigo" />
            </Text>

            <TouchableOpacity onPress={openBoleto} style={styles.openButton}>
              <Image
                source={require("../../../assets/pdf-download.svg")}
                style={styles.img}
              />
              <Text style={styles.copyText}>
                <FormattedMessage id="depositboleto.abrirBoleto" />
              </Text>
            </TouchableOpacity>

            <View style={styles.codeContainer}>
              <Text
                style={{
                  textAlign: "center",
                  width: "80%",
                  flexWrap: "wrap",
                  fontSize: 12,
                }}
              >
                {boletoCode}
              </Text>
              <View style={styles.codeHeader}>
                {/* <Text style={styles.bold}>
                  <FormattedMessage id="depositboleto.codigo"/>
                  </Text> */}

                <TouchableOpacity onPress={copyToClipboard}>
                  <Text style={styles.copyText}>
                    {copied ? (
                      <FormattedMessage id="depositboleto.copiado" />
                    ) : (
                      <FormattedMessage id="depositboleto.copiar" />
                    )}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.dateContainer}>
              <Text style={styles.bold}>
                <FormattedMessage id="depositboleto.validade" />
                {expirationDate && formatDate(expirationDate)}
              </Text>
            </View>
          </View>
          <View style={{ alignSelf: "center", minWidth: 320 }}>
            <TouchableOpacity
              onPress={() => navigation.navigate("Home")}
              style={styles.actionButton}
            >
              <Text style={styles.actionButtonText}>
                <FormattedMessage id="depositboleto.finalizar" />
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      )}
    </View>
  );
};

export default DepositBoleto;
